import axios from "axios"
import { BASE_URL } from "../index"

export const getEquipmentList = async () => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetDeviceDetails`
    );

    return response.data.resultSet || [];
}

export const getDeviceSourceList = async () => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetDeviceTypeList`
    )

    return response.data.resultSet || [];
}

export const saveEquipment = async (equipment) => {

    const userInfo = JSON.parse(
        localStorage.getItem("userInfo")
    );

    const params = new URLSearchParams({
        DeviceId: equipment.DeviceId,
        DeviceCode: equipment.DeviceCode,
        DeviceName: equipment.DeviceName,
        DeviceType: equipment.DeviceType,
        SerialNumber: equipment.SerialNumber,
        IPAddress: "",
        Location: equipment.Location || "CDL",
        FirmwareVersion: "",
        Status: equipment.Status || "A",
        CreatedBy: userInfo?.ServiceNumber || ""
    });
    
    const response = await axios.post(
        `${BASE_URL}/PowerMeter/PostDevice?${params.toString()}`
    );

    return response.data
}